import {GameData} from "../../../server/data/GameData";
import {Presentation} from "../../../../core/gameflow/controller/Presentation";
import {NoWinPosterState, PosterManager} from "../../independent/Poster/PosterManager";
import {PunkRocker} from "../../../PunkRocker";
import {SoundManager} from "../../../sound/SoundManager";
import {MathHelper} from "../../../../core/utils/MathHelper";
import {SoundConfig} from "../../../sound/SoundConfig";
import {TrainState} from "../../independent/trains/TrainState";
import {PRGameMode} from "../../../server/PRGameMode";

export class OutroPresentation extends Presentation {


    protected totalWinAmount: number = 0;
    protected _state: string = "Post";
    protected currWon: boolean = false;
    protected _brokeTheBank: boolean = false;
    // #423
    private _winBelowStake: boolean = false;
    private _bonusType: number = -1;

    public setGamedData(data: any): void {
        const mode:string = data.raw.mode;
        this.totalWinAmount = data.Win.totalWin;
        this.currWon = data.Win.singleWin > 0;
        this._brokeTheBank = data.raw.brokeTheBank;
        // #423
        this._winBelowStake = data.Win.isWinBelowStake();
        this._state = (!this._winBelowStake && (this.totalWinAmount / data.Win.playedBetValue <= 10)) ? "Post" : "Done";
        this._bonusType = (mode === PRGameMode.FREESPIN_LEVEL_ONE ? 0 : (mode === PRGameMode.FREESPIN_LEVEL_TWO ? 1 : 2));

        PunkRocker.fsOutro.setData(data);
    }

    checkForActivation(data: GameData): boolean {
        return data.lastFSRound;
    }

    preStart(): void {
    }

    createPresentation(quickStop: Function) {
        quickStop(false);
        if (PunkRocker.counter.timeRemaining) {
            this.timeline.to(this, {duration: PunkRocker.counter.timeRemaining})
        }


        switch (this._state) {
            case "Post":
                this.post();
                this._state = "Done";
                break
            default:
                this.TotalWin();
                this.PresentationState.setInactive();
                break;
        }
    }

    skip(): void {
    }

    done(): void {
        SoundManager.stopSoundEffect(SoundConfig.FS_GAME_AMBIANCE[this._bonusType]);
    }

    protected post(): void {
        if (this.currWon) {
            this.timeline.to(this, {
                duration: 1
            });
        }

        // #351
        if (this.totalWinAmount < (PunkRocker.model.gameData.Win.playedBetValue * 15)) {
            this.timeline.add(PunkRocker.fsOutro.playNoWinAnimation());
        }

        // this.timeline.add(PosterManager.instance.play(NoWinPosterState.NO_WIN, {animation: NoWinPosterState.MONEY}));
        // this.timeline.add(() => {PosterManager.instance.play(NoWinPosterState.NO_WIN,{animation:NoWinPosterState.QUEEN2})});
        // this.timeline.to(this,0.800,{});
        // this.timeline.add(() => PunkRocker.featurePrice.reset());
    }

    protected TotalWin(): void {
        PosterManager.instance.stop();
        PunkRocker.keypadPlugin.setZeroBetSpinCounter(-1);
        PunkRocker.waysCounter.hardSetValue(Math.pow(3, 6));
        if (this._brokeTheBank) {
            //TODO: Reset trains to base game state without sounds
            PunkRocker.trainsManager.topTrain.showTrainItems(false, [], 0);
            PunkRocker.trainsManager.bottomTrain.showTrainItems(false, [], 0);
            PunkRocker.trainsManager.topTrain.setTrainAlpha(false, 0.5);
            PunkRocker.trainsManager.bottomTrain.setTrainAlpha(false, 0.5);
            return;
        }
        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.showGlowPositions([0, 1, 2, 3, 4, 5], false, 0.3);
            PunkRocker.trainsManager.bottomTrain.showGlowPositions([0, 1, 2, 3, 4, 5], false, 0.3);
            PunkRocker.trainsManager.topTrain.showTrainItems(false, [], 0.3);
            PunkRocker.trainsManager.bottomTrain.showTrainItems(false, [], 0.3);
        });

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.setTrainState(TrainState.TRAIN_CLOSE_EXIT);
            PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_CLOSE_EXIT);
        }, this.timeline.totalDuration() + MathHelper.frameToSeconds(10));

        this.timeline.to(this, {
            duration: PunkRocker.trainsManager.topTrain.getAnimDuration(TrainState.TRAIN_STOP_OPEN)
        });

        this.timeline.add([
            () => {
                PunkRocker.waysCounter.totalWinMorse(0.5, true);
                PunkRocker.trainsManager.topTrain.setTrainAlpha(false, 0.5);
                PunkRocker.trainsManager.bottomTrain.setTrainAlpha(false, 0.5);
            }
        ], "-=" + 0.2);

        this.timeline.add(()=>{PunkRocker.waysCounter.counterActive(true);}, "+=0.5");
        this.timeline.add(PunkRocker.fsOutro.showFSOutro());
    }
}